import gql from 'graphql-tag'

export default gql`
	query listProductAdditionItems($filter: ProductAdditionItemFilter) {
		cashAssist {
			listProductAdditionItems(filter: $filter) {
				id
				productId
				product {
					id
					name
				}
			}
		}
	}
`
